import corner1 from 'assets/img/illustrations/corner-1.png';
import classNames from 'classnames';
import Background from 'components/common/Background';
import FalconCloseButton from 'components/common/FalconCloseButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import ModalActualizarFechaVencimiento from 'akasia-components/cliente/orden/Modales/ModalActualizarFechaVencimiento';
import React, { useEffect, useState } from 'react';
import { Col, Modal, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faQuestionCircle, faStar } from '@fortawesome/free-solid-svg-icons';
import SoftBadge from 'components/common/SoftBadge';


const ModalOrdenesDeuda = ({
    idUsuario = 0,
    showModalOrdenesVencidas,
    setShowModalOrdenesVencidas 
}) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    
    const [showSeguimientoModal, setShowSeguimientoModal] = useState(false);
    const [ordenSeleccionada, setOrdenSeleccionada] = useState(null);

    //Columnas
    const columnsOrdenesDeudas = [
        {
            accessor: 'idOrden',
            Header: 'Detalles de Orden',
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { idOrden, vNombreCliente, bIsActive } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center flex-wrap gap-2 py-1">
                        <Link to={"/ordenes/detalle/" + idOrden} className="text-decoration-none">
                            <span className={classNames("fs-0 fw-bold", {
                                "text-danger": bIsActive == false,
                                "text-primary": bIsActive != false
                            })}>#{idOrden}</span>
                        </Link>
                        <span className={classNames("fs--1 fw-semi-bold", {
                            "text-danger": bIsActive == false,
                            "text-800": bIsActive != false
                        })}>
                            <FontAwesomeIcon icon="user" className="me-1 text-500" />
                            {vNombreCliente}
                        </span>
                    </div>
                );
            }
        },
        {
            accessor: 'dFechaVenta',
            Header: 'Venta',
            Cell: rowData => {
                const { dFechaVenta } = rowData.row.original;

                return (
                    <div className="d-flex align-items-center py-1">
                        <div className="text-800 fw-semi-bold d-flex align-items-center fs--1">
                            <FontAwesomeIcon icon="calendar-check" className="me-2 text-success" />
                            {new Date(dFechaVenta).toLocaleDateString('es-mx', { year: 'numeric', month: 'short', day: 'numeric' })}
                        </div>
                    </div>
                );
            }
        },
        {
            accessor: 'dTotal',
            Header: 'Total',
            Cell: rowData => {
                const { dTotal } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center justify-content-end h-100 py-1">
                        <span className="fs--1 fw-bold text-900">
                            ${parseFloat(dTotal).toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                        </span>
                    </div>
                );
            }
        },
        {
            accessor: 'dImportePagado',
            Header: 'Abonos',
            Cell: rowData => {
                const { dImportePagado } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center justify-content-end h-100 py-1">
                        <span className="fs--1 fw-bold text-success">
                            ${parseFloat(dImportePagado).toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                        </span>
                    </div>
                );
            }
        },
        {
            accessor: 'dDeuda',
            Header: 'Deuda',
            Cell: rowData => {
                const { dDeuda } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center justify-content-end h-100 py-1">
                        <span className="fs--1 text-danger fw-bold">
                            ${parseFloat(dDeuda).toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                        </span>
                    </div>
                );
            }
        },
        {
            accessor: 'vMoneda',
            Header: 'Moneda',
            Cell: rowData => {
                const { vMoneda, dTipoCambio } = rowData.row.original;
                return (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 py-1">
                        <span className="fs--1 fw-semi-bold mb-1 text-800">
                            {vMoneda}
                        </span>
                        {vMoneda === 'USD' && (
                            <span className="fs--2 text-500 fw-semi-bold">
                                T.C. {dTipoCambio}
                            </span>
                        )}
                    </div>
                );
            }
        },
        {
            accessor: 'dFechaVencimiento',
            Header: 'Vencimiento',
            Cell: rowData => {
                const { dFechaVencimiento } = rowData.row.original;
                
                const fechaVencimiento = new Date(dFechaVencimiento);
                fechaVencimiento.setHours(0,0,0,0);
                const hoy = new Date();
                hoy.setHours(0,0,0,0);
                const diffTime = hoy - fechaVencimiento;
                const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

                return (
                    <div className="d-flex flex-column align-items-start gap-1 py-1">
                        <div className="d-flex align-items-center flex-wrap gap-2">
                            <div className="text-800 fs--1 fw-semi-bold d-flex align-items-center">
                                <FontAwesomeIcon icon={faClock} className="me-1 text-500" />
                                {fechaVencimiento.toLocaleDateString('es-mx', { year: 'numeric', month: 'short', day: 'numeric' })}
                            </div>
                        </div>
                        {diffDays > 0 && (
                            <span className="fs--2 text-danger fw-semi-bold">
                                Vencida hace {diffDays} {diffDays === 1 ? 'día' : 'días'}
                            </span>
                        )}
                        {diffDays === 0 && (
                            <span className="fs--2 text-warning fw-semi-bold">
                                <FontAwesomeIcon icon={faStar} bounce className="me-1" />
                                ¡Vence hoy!
                            </span>
                        )}
                    </div>
                );
            }
        },
        {
            accessor: 'Estatus',
            Header: 'Estado',
            Cell: rowData => {
                const { Estatus } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center justify-content-center h-100 py-1 gap-2">
                        <SoftBadge bg={Estatus == "Vencida" ? "danger" : "success"} className="fs--1 px-2 py-1">
                            {Estatus == "Deuda" ? "Vigente" : Estatus}
                        </SoftBadge>
                        {Estatus == "Vencida" && (
                            <OverlayTrigger placement="top" overlay={<Tooltip>¿Por qué no se ha cobrado?</Tooltip>}>
                                <div className="text-danger" style={{ cursor: 'pointer' }} onClick={() => {
                                    setOrdenSeleccionada(rowData.row.original);
                                    setShowSeguimientoModal(true);
                                }}>
                                    <FontAwesomeIcon icon={faQuestionCircle} bounce />
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>
                );
            }
        }
    ];
    
    const [ordenesDeudas, setOrdenesDeudas] = useState([]);
    const ObtenerOrdenesConDeudas = async (idUsuario) => { 
        setShowModalOrdenesVencidas(false);
        const response = await fetch("/api/home/ObtenerOrdenesConDeuda?idUsuario=" + idUsuario, {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response.ok) {
            console.log("**********************ORDENES CON DEUDA**********************");
            console.log(response);
            const objResponse = await response.json();
            console.log(objResponse);
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                console.log(data);
                setOrdenesDeudas(data);
                if (data.length > 0)
                    setShowModalOrdenesVencidas(true);
            }
            console.log("**********************ORDENES CON DEUDA**********************");
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    useEffect(() => {
        ObtenerOrdenesConDeudas(idUsuario);
    },[idUsuario]);

    useEffect(() => {
        if (showModalOrdenesVencidas) {
            window.dispatchEvent(new Event('OrdenesDeudaOpened'));
        } else {
            window.dispatchEvent(new Event('OrdenesDeudaClosed'));
        }
    }, [showModalOrdenesVencidas]);

    return (
        <>
            {
                showModalOrdenesVencidas &&
                <Modal
                    show={showModalOrdenesVencidas}
                    onHide={() => { setShowModalOrdenesVencidas(false); }}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Background image={corner1} className="p-x1 bg-card" style={{ zIndex: 0, opacity: 0.5 }} />
                    <Modal.Header className="bg-light px-4 py-3 border-bottom position-relative">
                        <div className="d-flex align-items-center gap-3">
                            <div className="d-flex align-items-center justify-content-center bg-danger-subtle text-danger rounded-circle" style={{ width: '40px', height: '40px' }}>
                                <FontAwesomeIcon icon="exclamation-triangle" className="fs-1" />
                            </div>
                            <div>
                                <Modal.Title className="fs-2 fw-bold text-800 mb-0">
                                    Órdenes con deudas pendientes
                                </Modal.Title>
                                <p className="mb-0 fs--1 text-500">Se requiere atención en las siguientes órdenes vencidas</p>
                            </div>
                        </div>
                        <FalconCloseButton style={{ zIndex: 1 }} className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalOrdenesVencidas(false); }} />
                    </Modal.Header>
                    <Modal.Body className="p-0 bg-white">
                        <Row>
                            <Col className="col-12">
                                <Row>
                                    <Col>
                                        <AdvanceTableWrapper
                                            columns={columnsOrdenesDeudas}
                                            data={ordenesDeudas}
                                            sortable
                                            pagination
                                            perPage={6}
                                        >
                                            <AdvanceTable
                                                table
                                                headerClassName="bg-200 text-900 text-nowrap align-middle"
                                                rowClassName="align-middle white-space-nowrap"
                                                tableProps={{
                                                    size: 'sm',
                                                    striped: false,
                                                    className: 'fs--2 mb-0 overflow-hidden'
                                                }}
                                            />
                                            <div className="px-4 py-3 border-top bg-light">
                                                <AdvanceTableFooter
                                                    rowCount={ordenesDeudas.length}
                                                    table
                                                    rowInfo
                                                    navButtons
                                                    rowsPerPageSelection
                                                />
                                            </div>
                                        </AdvanceTableWrapper>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            }

            {showSeguimientoModal && ordenSeleccionada && (
                <ModalActualizarFechaVencimiento
                    showModal={showSeguimientoModal}
                    setShowModal={setShowSeguimientoModal}
                    ordenSeleccionada={ordenSeleccionada}
                    onSuccessCallback={() => ObtenerOrdenesConDeudas(idUsuario)}
                />
            )}
        </>
    );
};

ModalOrdenesDeuda.propTypes = {
    idUsuario: PropTypes.number,
    showModalOrdenesVencidas: PropTypes.bool,
    setShowModalOrdenesVencidas: PropTypes.func,
};


export default ModalOrdenesDeuda;